﻿import {styled} from "@mui/material/styles";
import {Typography, TypographyProps} from "@mui/material";

type RevisedTypographyProps = TypographyProps & {
  isRevised?: boolean;
}

type RootType = RevisedTypographyProps;

const Root = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isRevised'
})(({isRevised}: RootType) => (isRevised && {
  backgroundColor: "#3F51B5",
  color: "white",
  paddingLeft: "5px",
  marginLeft: "-5px",
  borderRadius: "4px",
}));

const RevisedTypography = (props: RevisedTypographyProps) => {
  return <Root variant="subtitle2" {...props} />
}

export default RevisedTypography;
